import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {TEST_EXECUTION_VALIDATORS} from '../../../../constants/validators';
import {TestExecution} from '../../../data/models/execution/test-execution';
import {TestExecutionService} from '../../../services/api/execution/test-execution.service';
import {TelegramDetectorService} from '../../../services/telegram-detector.service';

@Component({
  selector: 'app-test-execution-register-form',
  templateUrl: './test-execution-register-form.component.html',
  styleUrls: ['./test-execution-register-form.component.css']
})
export class TestExecutionRegisterFormComponent implements OnInit {

  @Input() urlCode?: string;
  @Input() testId?: number;

  @Output() register = new EventEmitter<TestExecution>();

  registerForm = this.fb.group({
    studentName: ['', TEST_EXECUTION_VALIDATORS.STUDENT_NAME],
    studentMail: ['', TEST_EXECUTION_VALIDATORS.STUDENT_MAIL],
  });

  error = '';

  constructor(
    private fb: FormBuilder,
    private testExecutionService: TestExecutionService,
    private telegramDetectorService: TelegramDetectorService,
  ) {
  }

  ngOnInit(): void {
  }

  onSubmit(event: MouseEvent): void {
    this.error = '';
    event.preventDefault();
    if (this.registerForm.valid) {
      this.testExecutionService.addTestExecution({urlCode: this.urlCode, testId: this.testId}, {
        studentName: this.registerForm.controls.studentName.value,
        studentMail: this.registerForm.controls.studentMail.value,
        isTelegram: this.telegramDetectorService.isTelegramEnvironment(),
      }).then(testExecution => {
        this.register.emit(testExecution);
      })
      .catch(error => {
        this.error = 'Указана некорректная почта';
      });
    }
  }

}
